import * as THREE from 'three';

const MATTS_TREE: THREE.Vector3Tuple[] = [
    [0.547169811, -0.173584906, 0.698113208],
    [0.547169811, -0.173584906, 0.698113208],
    [0.547169811, -0.173584906, 0.698113208],
    [0.547169811, -0.173584906, 0.698113208],
    [0.547169811, -0.173584906, 0.698113208],
    [0.547169811, -0.173584906, 0.698113208],
    [0.547169811, -0.173584906, 0.698113208],
    [0.547169811, -0.173584906, 0.698113208],
    [0.547169811, -0.173584906, 0.698113208],
    [0.547169811, -0.173584906, 0.698113208],
    [0.547169811, -0.173584906, 0.698113208],
    [0.547169811, -0.173584906, 0.698113208],
    [0.547169811, -0.173584906, 0.698113208],
    [0.547169811, -0.173584906, 0.698113208],
    [0.547169811, -0.173584906, 0.698113208],
    [0.547169811, -0.173584906, 0.698113208],
    [0.547169811, -0.173584906, 0.698113208],
    [0.547169811, -0.173584906, 0.698113208],
    [0.547169811, -0.173584906, 0.698113208],
    [0.362264151, -0.188679245, 0.520754717],
    [0.343396226, -0.464150943, 0.347169811],
    [0.267924528, -0.441509434, 0.58490566],
    [0.305660377, -0.464150943, 0.581132075],
    [0.347169811, -0.490566038, 0.577358491],
    [0.388679245, -0.513207547, 0.573584906],
    [0.430188679, -0.539622642, 0.569811321],
    [0.471698113, -0.566037736, 0.562264151],
    [0.550943396, -0.833962264, 0.479245283],
    [0.509433962, -0.924528302, 0.645283019],
    [0.532075472, -0.905660377, 0.396226415],
    [0.509433962, -0.901886792, 0.4],
    [0.486792453, -0.901886792, 0.403773585],
    [0.464150943, -0.901886792, 0.40754717],
    [0.441509434, -0.901886792, 0.411320755],
    [0.418867925, -0.901886792, 0.41509434],
    [0.396226415, -0.901886792, 0.418867925],
    [0.373584906, -0.901886792, 0.422641509],
    [0.350943396, -0.901886792, 0.426415094],
    [0.332075472, -0.901886792, 0.430188679],
    [0.309433962, -0.901886792, 0.433962264],
    [0.286792453, -0.901886792, 0.437735849],
    [0.264150943, -0.901886792, 0.441509434],
    [0.241509434, -0.901886792, 0.445283019],
    [0.218867925, -0.901886792, 0.449056604],
    [0.196226415, -0.901886792, 0.452830189],
    [0.173584906, -0.901886792, 0.456603774],
    [0.154716981, -0.901886792, 0.460377358],
    [0.132075472, -0.901886792, 0.464150943],
    [0.109433962, -0.901886792, 0.467924528],
    [0.086792453, -0.901886792, 0.471698113],
    [0.067924528, -0.901886792, 0.475471698],
    [0.045283019, -0.901886792, 0.479245283],
    [0.022641509, -0.901886792, 0.483018868],
    [0, -0.901886792, 0.486792453],
    [-0.022641509, -0.901886792, 0.486792453],
    [-0.030188679, -0.920754717, 0.245283019],
    [0.083018868, -0.811320755, 0.396226415],
    [0.056603774, -0.78490566, 0.4],
    [0.030188679, -0.762264151, 0.4],
    [0.003773585, -0.739622642, 0.4],
    [-0.022641509, -0.716981132, 0.4],
    [-0.049056604, -0.694339623, 0.4],
    [-0.075471698, -0.671698113, 0.4],
    [-0.101886792, -0.649056604, 0.4],
    [-0.128301887, -0.626415094, 0.4],
    [-0.154716981, -0.603773585, 0.4],
    [-0.181132075, -0.581132075, 0.4],
    [-0.20754717, -0.558490566, 0.4],
    [-0.233962264, -0.535849057, 0.403773585],
    [-0.260377358, -0.513207547, 0.403773585],
    [-0.286792453, -0.490566038, 0.403773585],
    [-0.313207547, -0.467924528, 0.403773585],
    [-0.339622642, -0.445283019, 0.403773585],
    [-0.366037736, -0.422641509, 0.403773585],
    [-0.39245283, -0.4, 0.403773585],
    [-0.418867925, -0.377358491, 0.403773585],
    [-0.445283019, -0.354716981, 0.403773585],
    [-0.471698113, -0.332075472, 0.403773585],
    [-0.498113208, -0.309433962, 0.403773585],
    [-0.41509434, -0.196226415, 0.562264151],
    [-0.343396226, -0.222641509, 0.241509434],
    [-0.343396226, -0.275471698, 0.509433962],
    [-0.347169811, -0.120754717, 0.41509434],
    [-0.403773585, -0.120754717, 0.4],
    [-0.464150943, -0.120754717, 0.38490566],
    [-0.524528302, -0.120754717, 0.366037736],
    [-0.58490566, -0.124528302, 0.350943396],
    [-0.645283019, -0.124528302, 0.332075472],
    [-0.701886792, -0.124528302, 0.316981132],
    [-0.762264151, -0.128301887, 0.301886792],
    [-0.822641509, -0.128301887, 0.283018868],
    [-0.883018868, -0.128301887, 0.267924528],
    [-0.943396226, -0.132075472, 0.249056604],
    [-0.826415094, -0.060377358, 0.011320755],
    [-0.875471698, -0.120754717, 0.275471698],
    [-0.864150943, -0.083018868, 0.294339623],
    [-0.852830189, -0.045283019, 0.313207547],
    [-0.841509434, -0.01509434, 0.328301887],
    [-0.830188679, 0.022641509, 0.347169811],
    [-0.818867925, 0.056603774, 0.366037736],
    [-0.80754717, 0.094339623, 0.381132075],
    [-0.796226415, 0.128301887, 0.4],
    [-0.78490566, 0.166037736, 0.41509434],
    [-0.773584906, 0.2, 0.433962264],
    [-0.762264151, 0.237735849, 0.452830189],
    [-0.750943396, 0.271698113, 0.467924528],
    [-0.739622642, 0.309433962, 0.486792453],
    [-0.728301887, 0.347169811, 0.501886792],
    [-0.773584906, 0.154716981, 0.267924528],
    [-0.886792453, 0.316981132, 0.2],
    [-1, 0.581132075, 0.343396226],
    [-0.916981132, 0.603773585, 0.105660377],
    [-0.788679245, 0.316981132, 0.109433962],
    [-0.569811321, 0.445283019, 0.283018868],
    [-0.618867925, 0.475471698, 0.162264151],
    [-0.6, 0.486792453, 0.177358491],
    [-0.58490566, 0.501886792, 0.19245283],
    [-0.569811321, 0.516981132, 0.20754717],
    [-0.550943396, 0.528301887, 0.222641509],
    [-0.535849057, 0.543396226, 0.237735849],
    [-0.520754717, 0.558490566, 0.252830189],
    [-0.505660377, 0.573584906, 0.264150943],
    [-0.713207547, 0.664150943, 0.433962264],
    [-0.562264151, 0.437735849, 0.652830189],
    [-0.630188679, 0.626415094, 0.905660377],
    [-0.516981132, 0.38490566, 1.049056604],
    [-0.698113208, 0.490566038, 1.150943396],
    [-0.418867925, 0.41509434, 1.260377358],
    [-0.596226415, 0.4, 1.301886792],
    [-0.566037736, 0.309433962, 1.196226415],
    [-0.539622642, 0.222641509, 1.090566038],
    [-0.471698113, 0.279245283, 1.188679245],
    [-0.267924528, 0.026415094, 1.154716981],
    [-0.267924528, 0.030188679, 1.162264151],
    [-0.267924528, 0.033962264, 1.166037736],
    [-0.271698113, 0.037735849, 1.169811321],
    [-0.271698113, 0.041509434, 1.173584906],
    [-0.275471698, 0.045283019, 1.181132075],
    [-0.275471698, 0.049056604, 1.18490566],
    [-0.279245283, 0.052830189, 1.188679245],
    [-0.279245283, 0.056603774, 1.19245283],
    [-0.283018868, 0.060377358, 1.196226415],
    [-0.056603774, 0.030188679, 1.377358491],
    [-0.188679245, -0.124528302, 1.249056604],
    [-0.226415094, -0.003773585, 1.2],
    [-0.230188679, 0.079245283, 1.116981132],
    [-0.233962264, 0.166037736, 1.033962264],
    [-0.241509434, 0.252830189, 0.947169811],
    [-0.245283019, 0.339622642, 0.864150943],
    [-0.249056604, 0.422641509, 0.781132075],
    [-0.256603774, 0.509433962, 0.694339623],
    [-0.260377358, 0.596226415, 0.611320755],
    [-0.267924528, 0.683018868, 0.524528302],
    [-0.426415094, 0.909433962, 0.516981132],
    [-0.305660377, 0.920754717, 0.222641509],
    [-0.279245283, 0.909433962, 0.218867925],
    [-0.256603774, 0.901886792, 0.21509434],
    [-0.230188679, 0.890566038, 0.211320755],
    [-0.20754717, 0.883018868, 0.203773585],
    [-0.18490566, 0.871698113, 0.2],
    [-0.158490566, 0.864150943, 0.196226415],
    [-0.135849057, 0.852830189, 0.188679245],
    [-0.109433962, 0.845283019, 0.18490566],
    [-0.086792453, 0.833962264, 0.181132075],
    [-0.064150943, 0.826415094, 0.173584906],
    [-0.037735849, 0.81509434, 0.169811321],
    [-0.01509434, 0.80754717, 0.166037736],
    [0.011320755, 0.8, 0.158490566],
    [0.033962264, 0.788679245, 0.154716981],
    [0.056603774, 0.781132075, 0.150943396],
    [0.079245283, 0.769811321, 0.143396226],
    [0.101886792, 0.762264151, 0.139622642],
    [0.128301887, 0.750943396, 0.135849057],
    [0.150943396, 0.743396226, 0.132075472],
    [0.177358491, 0.732075472, 0.124528302],
    [0.2, 0.724528302, 0.120754717],
    [0.222641509, 0.713207547, 0.116981132],
    [0.249056604, 0.705660377, 0.109433962],
    [0.271698113, 0.698113208, 0.105660377],
    [0.298113208, 0.686792453, 0.101886792],
    [0.320754717, 0.679245283, 0.094339623],
    [0.343396226, 0.667924528, 0.090566038],
    [0.369811321, 0.660377358, 0.086792453],
    [0.39245283, 0.649056604, 0.079245283],
    [0.418867925, 0.641509434, 0.075471698],
    [0.441509434, 0.630188679, 0.071698113],
    [0.464150943, 0.622641509, 0.064150943],
    [0.490566038, 0.611320755, 0.060377358],
    [0.513207547, 0.603773585, 0.056603774],
    [0.539622642, 0.596226415, 0.049056604],
    [0.433962264, 0.4, 0.169811321],
    [0.577358491, 0.362264151, 0.041509434],
    [0.577358491, 0.305660377, 0.030188679],
    [0.550943396, 0.264150943, 0.064150943],
    [0.524528302, 0.226415094, 0.094339623],
    [0.501886792, 0.18490566, 0.124528302],
    [0.475471698, 0.147169811, 0.154716981],
    [0.449056604, 0.105660377, 0.18490566],
    [0.426415094, 0.067924528, 0.21509434],
    [0.547169811, 0.064150943, 0.411320755],
    [0.403773585, -0.022641509, 0.456603774],
    [0.188679245, 0.075471698, 0.222641509],
    [0.339622642, 0.132075472, 0.113207547],
    [0.490566038, 0.19245283, 0],
    [0.59245283, 0.249056604, 0.150943396],
    [0.660377358, 0.324528302, 0.2],
    [0.660377358, 0.335849057, 0.290566038],
    [0.675471698, 0.169811321, 0.456603774],
    [0.743396226, 0.18490566, 0.449056604],
    [0.81509434, 0.203773585, 0.437735849],
    [0.886792453, 0.218867925, 0.430188679],
    [0.958490566, 0.237735849, 0.418867925],
    [0.811320755, 0.196226415, 0.60754717],
    [0.750943396, 0.158490566, 0.573584906],
    [0.622641509, 0, 0.637735849],
    [0.535849057, 0.052830189, 0.728301887],
    [0.441509434, -0.079245283, 0.977358491],
    [0.411320755, 0.116981132, 1.011320755],
    [0.305660377, 0.113207547, 1.188679245],
    [0.39245283, 0.20754717, 1.203773585],
    [0.483018868, 0.301886792, 1.218867925],
    [0.637735849, 0.328301887, 0.928301887],
    [0.532075472, 0.332075472, 1.105660377],
    [0.558490566, 0.067924528, 1.245283019],
    [0.524528302, 0.098113208, 1.143396226],
    [0.494339623, 0.128301887, 1.041509434],
    [0.464150943, 0.158490566, 0.935849057],
    [0.550943396, 0.056603774, 0.811320755],
    [0.501886792, 0.256603774, 0.99245283],
    [0.641509434, 0.535849057, 0.826415094],
    [0.649056604, 0.362264151, 0.905660377],
    [0.656603774, 0.188679245, 0.98490566],
    [0.747169811, 0.18490566, 0.656603774],
    [0.581132075, 0.362264151, 0.558490566],
    [0.766037736, 0.449056604, 0.61509434],
    [0.954716981, 0.535849057, 0.667924528],
    [0.716981132, 0.550943396, 0.750943396],
    [0.920754717, 0.581132075, 0.958490566],
    [0.762264151, 0.532075472, 1.022641509],
    [0.954716981, 0.350943396, 0.849056604],
    [0.947169811, 0.324528302, 0.943396226],
    [0.939622642, 0.298113208, 1.037735849],
    [0.932075472, 0.271698113, 1.132075472],
    [0.924528302, 0.245283019, 1.226415094],
    [0.935849057, -0.071698113, 1.222641509],
    [1, -0.00754717, 1.430188679],
    [0.867924528, -0.230188679, 1.494339623],
    [0.758490566, -0.362264151, 1.467924528],
    [0.762264151, -0.290566038, 1.520754717],
    [0.766037736, -0.218867925, 1.573584906],
    [0.769811321, -0.150943396, 1.626415094],
    [0.773584906, -0.079245283, 1.679245283],
    [0.777358491, -0.011320755, 1.735849057],
    [0.679245283, 0.158490566, 1.928301887],
    [0.486792453, 0.105660377, 1.860377358],
    [0.460377358, 0.139622642, 1.79245283],
    [0.433962264, 0.173584906, 1.728301887],
    [0.411320755, 0.20754717, 1.664150943],
    [0.38490566, 0.241509434, 1.6],
    [0.358490566, 0.275471698, 1.532075472],
    [0.335849057, 0.309433962, 1.467924528],
    [0.309433962, 0.343396226, 1.403773585],
    [0.286792453, 0.381132075, 1.339622642],
    [0.339622642, 0.554716981, 1.516981132],
    [0.369811321, 0.309433962, 1.528301887],
    [0.569811321, 0.449056604, 1.313207547],
    [0.516981132, 0.532075472, 1.150943396],
    [0.611320755, 0.41509434, 1.113207547],
    [0.4, 0.524528302, 1.00754717],
    [0.596226415, 0.475471698, 0.977358491],
    [0.528301887, 0.494339623, 1.00754717],
    [0.460377358, 0.513207547, 1.037735849],
    [0.39245283, 0.535849057, 1.067924528],
    [0.324528302, 0.554716981, 1.098113208],
    [0.256603774, 0.577358491, 1.124528302],
    [0.188679245, 0.596226415, 1.154716981],
    [0.120754717, 0.61509434, 1.18490566],
    [0.052830189, 0.637735849, 1.211320755],
    [-0.01509434, 0.656603774, 1.241509434],
    [-0.083018868, 0.679245283, 1.271698113],
    [-0.026415094, 0.547169811, 1.045283019],
    [-0.101886792, 0.79245283, 1.00754717],
    [0.139622642, 0.747169811, 0.871698113],
    [0.116981132, 0.773584906, 1],
    [0.094339623, 0.8, 1.124528302],
    [0.2, 0.875471698, 0.966037736],
    [-0.011320755, 0.8, 1],
    [-0.071698113, 0.822641509, 0.671698113],
    [-0.226415094, 0.8, 0.901886792],
    [-0.211320755, 0.664150943, 0.803773585],
    [-0.030188679, 0.81509434, 0.698113208],
    [-0.075471698, 0.79245283, 0.709433962],
    [-0.120754717, 0.769811321, 0.716981132],
    [-0.166037736, 0.750943396, 0.724528302],
    [-0.211320755, 0.728301887, 0.735849057],
    [-0.256603774, 0.709433962, 0.743396226],
    [-0.301886792, 0.686792453, 0.750943396],
    [-0.347169811, 0.667924528, 0.758490566],
    [-0.39245283, 0.645283019, 0.769811321],
    [-0.437735849, 0.626415094, 0.777358491],
    [-0.483018868, 0.603773585, 0.78490566],
    [-0.528301887, 0.58490566, 0.79245283],
    [-0.573584906, 0.562264151, 0.803773585],
    [-0.618867925, 0.543396226, 0.811320755],
    [-0.664150943, 0.520754717, 0.818867925],
    [-0.713207547, 0.501886792, 0.826415094],
    [-0.698113208, 0.467924528, 0.788679245],
    [-0.675471698, 0.550943396, 0.969811321],
    [-0.660377358, 0.347169811, 0.969811321],
    [-0.645283019, 0.147169811, 0.966037736],
    [-0.630188679, -0.049056604, 0.966037736],
    [-0.61509434, -0.252830189, 0.962264151],
    [-0.456603774, -0.00754717, 0.845283019],
    [-0.588679245, -0.105660377, 0.852830189],
    [-0.464150943, -0.00754717, 0.928301887],
    [-0.513207547, -0.071698113, 0.958490566],
    [-0.566037736, -0.139622642, 0.988679245],
    [-0.618867925, -0.20754717, 1.018867925],
    [-0.671698113, -0.271698113, 1.049056604],
    [-0.724528302, -0.339622642, 1.079245283],
    [-0.777358491, -0.40754717, 1.109433962],
    [-0.830188679, -0.471698113, 1.139622642],
    [-0.883018868, -0.539622642, 1.169811321],
    [-0.935849057, -0.60754717, 1.2],
    [-0.781132075, -0.403773585, 1.196226415],
    [-0.781132075, -0.475471698, 0.894339623],
    [-0.641509434, -0.479245283, 0.962264151],
    [-0.501886792, -0.483018868, 1.030188679],
    [-0.362264151, -0.486792453, 1.098113208],
    [-0.222641509, -0.490566038, 1.166037736],
    [-0.086792453, -0.498113208, 1.233962264],
    [-0.154716981, -0.381132075, 1.252830189],
    [-0.305660377, -0.411320755, 1.513207547],
    [-0.20754717, -0.445283019, 1.430188679],
    [-0.109433962, -0.479245283, 1.350943396],
    [-0.011320755, -0.513207547, 1.271698113],
    [0.086792453, -0.547169811, 1.196226415],
    [0.18490566, -0.58490566, 1.113207547],
    [0.086792453, -0.709433962, 0.905660377],
    [0.2, -0.720754717, 0.939622642],
    [0.245283019, -0.867924528, 0.973584906],
    [0.403773585, -0.864150943, 0.920754717],
    [0.260377358, -0.720754717, 0.98490566],
    [0.283018868, -0.675471698, 0.98490566],
    [0.309433962, -0.630188679, 0.98490566],
    [0.335849057, -0.588679245, 0.98490566],
    [0.362264151, -0.543396226, 0.981132075],
    [0.388679245, -0.498113208, 0.981132075],
    [0.41509434, -0.456603774, 0.981132075],
    [0.441509434, -0.411320755, 0.981132075],
    [0.467924528, -0.369811321, 0.977358491],
    [0.618867925, -0.498113208, 1.011320755],
    [0.705660377, -0.520754717, 0.954716981],
    [0.769811321, -0.449056604, 0.950943396],
    [0.833962264, -0.381132075, 0.947169811],
    [0.630188679, -0.362264151, 1.011320755],
    [0.788679245, -0.618867925, 1.098113208],
    [0.61509434, -0.524528302, 0.894339623],
    [0.59245283, -0.516981132, 1.041509434],
    [0.464150943, -0.675471698, 0.973584906],
    [0.588679245, -0.520754717, 1.00754717],
    [0.373584906, -0.433962264, 1.098113208],
    [0.520754717, -0.626415094, 1.196226415],
    [0.373584906, -0.543396226, 1.256603774],
    [0.377358491, -0.535849057, 1.286792453],
    [0.38490566, -0.528301887, 1.320754717],
    [0.388679245, -0.520754717, 1.350943396],
    [0.396226415, -0.516981132, 1.38490566],
    [0.4, -0.509433962, 1.41509434],
    [0.40754717, -0.501886792, 1.449056604],
    [0.411320755, -0.494339623, 1.483018868],
    [0.418867925, -0.490566038, 1.513207547],
    [0.426415094, -0.483018868, 1.547169811],
    [0.430188679, -0.475471698, 1.577358491],
    [0.437735849, -0.467924528, 1.611320755],
    [0.441509434, -0.464150943, 1.645283019],
    [0.449056604, -0.456603774, 1.675471698],
    [0.452830189, -0.449056604, 1.709433962],
    [0.460377358, -0.441509434, 1.739622642],
    [0.464150943, -0.437735849, 1.773584906],
    [0.471698113, -0.430188679, 1.80754717],
    [0.479245283, -0.422641509, 1.837735849],
    [0.483018868, -0.41509434, 1.871698113],
    [0.490566038, -0.411320755, 1.901886792],
    [0.494339623, -0.403773585, 1.935849057],
    [0.501886792, -0.396226415, 1.969811321],
    [0.505660377, -0.388679245, 2],
    [0.513207547, -0.38490566, 2.033962264],
    [0.516981132, -0.377358491, 2.064150943],
    [0.524528302, -0.369811321, 2.098113208],
    [0.532075472, -0.366037736, 2.132075472],
    [0.298113208, -0.39245283, 1.909433962],
    [0.230188679, -0.573584906, 1.920754717],
    [0.290566038, -0.543396226, 1.852830189],
    [0.354716981, -0.513207547, 1.78490566],
    [0.41509434, -0.483018868, 1.716981132],
    [0.479245283, -0.452830189, 1.649056604],
    [0.441509434, -0.611320755, 1.603773585],
    [0.532075472, -0.39245283, 1.543396226],
    [0.475471698, -0.354716981, 1.667924528],
    [0.422641509, -0.320754717, 1.79245283],
    [0.369811321, -0.286792453, 1.920754717],
    [0.313207547, -0.249056604, 2.045283019],
    [0.260377358, -0.21509434, 2.169811321],
    [0.20754717, -0.181132075, 2.298113208],
    [0.071698113, -0.366037736, 2.471698113],
    [0.354716981, -0.294339623, 2.622641509],
    [0.354716981, -0.369811321, 2.622641509],
    [0.264150943, -0.188679245, 2.675471698],
    [0.298113208, -0.260377358, 2.456603774],
    [-0.003773585, -0.422641509, 2.916981132],
    [-0.071698113, -0.339622642, 2.762264151],
    [0.071698113, -0.377358491, 2.916981132],
    [0.124528302, -0.279245283, 2.875471698],
    [0.177358491, -0.181132075, 2.837735849],
    [0.101886792, -0.124528302, 2.935849057],
    [0.147169811, -0.249056604, 3.218867925],
    [-0.00754717, -0.083018868, 3.233962264],
    [0.083018868, -0.147169811, 3.003773585],
    [-0.01509434, -0.022641509, 3.045283019],
    [0.075471698, -0.18490566, 2.781132075],
    [-0.158490566, -0.071698113, 2.762264151],
    [-0.139622642, -0.128301887, 2.641509434],
    [-0.139622642, -0.377358491, 2.61509434],
    [-0.275471698, -0.411320755, 2.58490566],
    [-0.218867925, -0.328301887, 2.252830189],
    [-0.21509434, -0.135849057, 2.252830189],
    [-0.332075472, -0.286792453, 2.264150943],
    [-0.550943396, -0.430188679, 2.086792453],
    [-0.324528302, -0.181132075, 2.026415094],
    [-0.373584906, -0.173584906, 1.958490566],
    [-0.422641509, -0.166037736, 1.890566038],
    [-0.471698113, -0.158490566, 1.822641509],
    [-0.524528302, -0.150943396, 1.758490566],
    [-0.573584906, -0.143396226, 1.690566038],
    [-0.622641509, -0.135849057, 1.622641509],
    [-0.675471698, -0.128301887, 1.558490566],
    [-0.498113208, 0.060377358, 1.664150943],
    [-0.667924528, 0.188679245, 1.452830189],
    [-0.618867925, 0.313207547, 1.558490566],
    [-0.569811321, 0.437735849, 1.664150943],
    [-0.339622642, 0.267924528, 1.679245283],
    [-0.049056604, 0.354716981, 1.596226415],
    [-0.071698113, 0.335849057, 1.675471698],
    [-0.094339623, 0.316981132, 1.754716981],
    [-0.116981132, 0.298113208, 1.833962264],
    [-0.139622642, 0.279245283, 1.913207547],
    [-0.162264151, 0.260377358, 1.99245283],
    [-0.18490566, 0.241509434, 2.071698113],
    [-0.20754717, 0.226415094, 2.154716981],
    [-0.011320755, 0.211320755, 2.350943396],
    [0.116981132, 0.098113208, 2.516981132],
    [-0.147169811, 0.049056604, 2.550943396],
    [0.154716981, 0.075471698, 2.671698113],
    [0.064150943, -0.037735849, 2.901886792],
    [0.211320755, 0.188679245, 2.849056604],
    [0.166037736, -0.052830189, 2.935849057],
    [0.332075472, -0.022641509, 2.890566038],
    [0.279245283, -0.154716981, 2.679245283],
    [0.222641509, -0.124528302, 2.479245283],
    [0.309433962, 0.086792453, 2.60754717],
    [0.279245283, 0.135849057, 2.547169811],
    [0.252830189, 0.188679245, 2.486792453],
    [0.222641509, 0.237735849, 2.430188679],
    [0.196226415, 0.290566038, 2.369811321],
    [0.169811321, 0.343396226, 2.309433962],
    [0.139622642, 0.39245283, 2.252830189],
    [0.113207547, 0.445283019, 2.19245283],
    [0.086792453, 0.498113208, 2.132075472],
    [0.060377358, 0.547169811, 2.075471698],
    [0.033962264, 0.6, 2.01509434],
    [0.003773585, 0.652830189, 1.958490566],
    [0.196226415, 0.709433962, 1.901886792],
    [0.332075472, 0.550943396, 1.611320755],
    [0.441509434, 0.554716981, 1.656603774],
    [0.377358491, 0.550943396, 1.686792453],
    [0.566037736, 0.581132075, 1.996226415],
    [0.479245283, 0.490566038, 1.996226415],
    [0.294339623, 0.335849057, 1.996226415],
    [0.18490566, 0.218867925, 2.098113208],
    [0.241509434, 0.203773585, 2.049056604],
    [0.301886792, 0.19245283, 2],
    [0.358490566, 0.181132075, 1.954716981],
    [0.418867925, 0.169811321, 1.905660377],
    [0.475471698, 0.158490566, 1.856603774],
    [0.535849057, 0.147169811, 1.811320755],
    [0.59245283, 0.135849057, 1.762264151],
    [0.652830189, 0.124528302, 1.713207547],
    [0.713207547, 0.113207547, 1.667924528],
    [0.698113208, -0.143396226, 1.664150943],
    [0.641509434, -0.033962264, 1.724528302],
    [0.645283019, -0.294339623, 1.883018868],
    [0.573584906, -0.226415094, 1.894339623],
    [0.505660377, -0.162264151, 1.909433962],
    [0.433962264, -0.094339623, 1.920754717],
    [0.366037736, -0.030188679, 1.935849057],
    [0.396226415, -0.033962264, 2.079245283],
    [0.2, -0.120754717, 2.267924528],
    [0.433962264, -0.271698113, 2.335849057],
    [0.433962264, -0.271698113, 2.335849057],
];

export default class Tree {
    ledCount: number
    lights: number[] = []
    height: number = 0;

    constructor(ledCount: number = 500) {
        this.ledCount = ledCount;

        for (let i = 0; i < ledCount; i++) {
            this.lights.push(0xffffff);
        }

        this.height = MATTS_TREE.reduce((previous, coordinates) => coordinates[2] > previous ? coordinates[2] : previous, 0);

    }

    getLightsCoordinates(): THREE.Vector3Tuple[] {
        return MATTS_TREE;
    }

    setLightsColors(lights: number[]) {
        if (lights.length !== this.lights.length) {
            throw new Error('Invalid number of lights. Expected ' + this.lights.length + ', got ' + lights.length);
        }

        this.lights = lights;
    }

    getLightsColors(): number[] {
        return this.lights;
    }
}
